// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__16fuT","productName":"Table_productName__A75JQ"};